import { Card, CardGroup } from '@ps/isp-web-component-library';
import React from 'react';

import type { MultipleReceiptItem, SingleReceiptItem } from '@swf/core/models/sports/betSlip/types';
import { ExpandablePanel } from '@swf/sports/components';

import { isSingleReceiptItems } from '../../../../../../utils/isReceiptItem';

import ReceiptItem from './components/ReceiptItem/ReceiptItem';

interface Props {
  isOpen: boolean;
  title: React.ReactElement<{ isOpen: boolean }>;
  receiptItems: SingleReceiptItem[] | MultipleReceiptItem[];
  accessibilityLabel?: string;
}

const ReceiptItems: React.FC<Props> = ({ isOpen, title, receiptItems, accessibilityLabel }) => {
  if (!receiptItems.length) {
    return null;
  }

  let content = (
    <Card isPadded>
      {receiptItems.map((receiptItem) => (
        <ReceiptItem key={receiptItem.id} receiptItem={receiptItem} />
      ))}
    </Card>
  );

  if (isSingleReceiptItems(receiptItems)) {
    content = (
      <>
        {receiptItems.map((receiptItem) => (
          <ReceiptItem key={receiptItem.id} receiptItem={receiptItem} />
        ))}
      </>
    );
  }

  return (
    <ExpandablePanel isOpenInitially={isOpen} title={title} accessibilityLabel={accessibilityLabel}>
      <CardGroup isCondensed isPadded>
        {content}
      </CardGroup>
    </ExpandablePanel>
  );
};

export default ReceiptItems;
